import React from "react";

import Box, { BoxProps } from "@mui/material/Box";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import styled from "@mui/material/styles/styled";
import { keyframes } from "@mui/system";

import BackIcon from "@readai/icons/uui/ArrowLeft";
import Stack from "@readai/pulse/components/Stack";

export const STICKY_CONTAINER_Z_INDEX = 10;

export const ELLIPSIS_SX: React.CSSProperties = {
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden",
};

export const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
  `;

/** Will apply a rounded outline to any element. Requires that the parent element be relatively positioned. */
export const roundedOutline = ({
  border,
  borderRadius,
  borderColor,
}: {
  border: React.CSSProperties["border"];
  borderRadius: React.CSSProperties["borderRadius"];
  borderColor?: React.CSSProperties["borderColor"];
}): { "&::after": React.CSSProperties } => ({
  "&::after": {
    pointerEvents: "none",
    content: "''",
    position: "absolute",
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    borderRadius,
    border,
    borderColor,
  },
});

export const BackButton = styled((props: IconButtonProps) => (
  <IconButton {...props} size="small">
    <BackIcon />
  </IconButton>
))(({ theme }) => ({
  color: theme.palette.icon.weak,
  borderRadius: "6px",
  "& svg": {
    height: "20px",
    width: "20px",
  },
}));

// TODO (ENG-15401): Improve semantics of Bold
export const Bold = styled("span")({
  fontWeight: 500,
});

export const Italic = styled("span")({
  fontStyle: "italic",
});

export const StickyContainer = styled(Stack)({
  position: "sticky",
  top: 0,
  zIndex: STICKY_CONTAINER_Z_INDEX,
});

/** Span that sx styles can be applied to */
export const Span = (props: BoxProps) => <Box {...props} component="span" />;

export const List = styled("ul")({
  marginBlockStart: "4px",
  marginBlockEnd: 0,
  paddingInlineStart: "24px",
});

export const Img = (props: BoxProps<"img">) => (
  <Box {...props} component="img" />
);
